import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { useMedia } from '@/hooks/responsive';

export function TrialPlan({ title, trialPlanPrice, discount }) {
	const { t } = useTranslation();
	const mdDown = useMedia('mdDown');

	return (
		<Box pt={{ xs: '12px', md: '16px' }}>
			<Stack flexDirection="row" justifyContent="space-between">
				<Typography
					variant={mdDown ? 'body2' : 'body3'}
					fontWeight={mdDown ? 500 : 400}
				>
					{title}
				</Typography>

				<Stack direction="row" alignItems="center" spacing={1} useFlexGap>
					{!!discount && (
						<Box
							display="flex"
							alignItems="center"
							justifyContent="center"
							sx={theme => ({
								background: theme.palette.text.primary,
								px: 0.5,
								height: 20,
								borderRadius: 1
							})}
						>
							<Typography
								variant="body0"
								fontWeight={700}
								color="background.default"
							>
								{t('common.discount', {
									discount
								})}
							</Typography>
						</Box>
					)}
					<Typography
						variant="body3"
						fontWeight={700}
						sx={{
							lineHeight: '28px',
							fontSize: { md: '24px' }
						}}
					>
						{trialPlanPrice}
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
}
